/** Les listes de valeurs du stock, telles que le serveur les énumère (`ChipTechnology`, `BadgeFormFactor`…). */
export const TECHNOLOGIES = ['mifare-classic-1k', 'mifare-classic-4k', 'mifare-classic-ev1', 'mifare-desfire-ev1', 'mifare-desfire-ev2', 'mifare-desfire-ev3', 'mifare-ultralight', 'ntag', 'other']
export const FORM_FACTORS = ['card', 'key-fob', 'sticker', 'wristband']
export const ORIENTATIONS = ['uid', 'uid-reversed', 'unrelated']
export const UID_LENGTHS = [4, 7, 10]
export const BATCH_STATUSES = ['to-check', 'released', 'blocked', 'recalled']
export const BADGE_STATUSES = ['available', 'active', 'suspended', 'retired', 'unconfirmed']

const BATCH_COLORS = { 'to-check': 'orange', released: 'green', blocked: 'red', recalled: 'grey' }
const BADGE_COLORS = { available: 'blue', active: 'green', suspended: 'orange', retired: 'grey', unconfirmed: 'brown' }

export default {
  methods: {
    /** Le message d'un refus : la clé traduite si on l'a, sinon celui que le serveur a traduit. */
    messageOf(e) {
      const data = e?.response?.data
      const key = data?.messageKey
      if (key && this.$te(key)) return this.$t(key, data.parameters || {})
      return data?.message || this.$t('error-occurred')
    },

    /** L'erreur d'une ligne de fichier, avec la valeur fautive ; rangée sous le dernier segment de sa clé. */
    lineErrorText(key, parameters) {
      const value = (parameters || {})[key]
      const path = `badge-inventory.line-error.${key.split('.').pop()}`
      return this.$te(path) ? this.$t(path, { value }) : key
    },

    /** Un texte du journal : une clé posée par le serveur (la reprise), traduite ; sinon ce qu'une personne a écrit. */
    keyedText(value) {
      return value && this.$te(value) ? this.$t(value) : value
    },

    technologyLabel(code) {
      return code ? this.$t(`badge-inventory.technology.${code}`) : ''
    },

    formFactorLabel(code) {
      return code ? this.$t(`badge-inventory.form-factor.${code}`) : ''
    },

    batchStatusLabel(status) {
      return this.$t(`badge-inventory.batch-status.${status}`)
    },

    batchStatusColor(status) {
      return BATCH_COLORS[status] || 'grey'
    },

    badgeStatusLabel(status) {
      return this.$t(`badge-inventory.badge-status.${status}`)
    },

    /** L'état d'un badge, au singulier (les compteurs disent « Disponibles », une ligne « Disponible »). */
    badgeStateLabel(status) {
      return this.$t(`badge-inventory.badge-state.${status}`)
    },

    badgeStatusColor(status) {
      return BADGE_COLORS[status] || 'grey'
    },

    batchName(batch) {
      return this.$t('badge-inventory.batch.name', { number: batch.number })
    },

    formatDate(value) {
      return value ? new Date(value).toLocaleDateString(this.$i18n.locale) : '—'
    },

    formatDateTime(value) {
      return value ? new Date(value).toLocaleString(this.$i18n.locale, { dateStyle: 'short', timeStyle: 'short' }) : '—'
    },

    items(values, labelOf) {
      return values.map(value => ({ value, text: labelOf(value) }))
    },
  },
}
